<template>
  <div class="information_shop">
    <div  class="ic_shop" >
       <img class="ic_shop_title" src="/static/img/top/ic-store.svg" width="20" height="20">
       <span class="ic_shop_title loading-font" >ストア</span>
    </div>
    <!--<div class="about_shop"  v-if="showAdArea">
      <div class="message_text">
        {{ strMsg }}
       </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'information-shop',
  props: {
    strMsg: { type: String, default: '' },
    showAdArea: { type: Boolean, default: false}
  },
}
</script>

<style lang="scss">
@import "../../../sass/variables/layout.scss";
.information_shop {
  @media screen and (max-width: $breakpoint) {
    padding: 10px; ;
    background: #FFFFFF;
    display: block;
    width: 100%;
  }
  @media screen and (max-width: 1020px ) {
    padding: 10px ;
  }
  display: flex;
  width: 1020px;
  margin: auto;
  padding: 24px 0 24px 0 ;
  font-size: 13px;
  color: #ed1e79;
  align-items: center;
  justify-items: center;
  place-items: center;
  overflow: hidden;

.about_shop {
  margin: 0;
  font-size: 14px;
  color: #676767;
  @media screen and (max-width: $breakpoint) {
    padding: 16px 4px 0 4px;
    font-size: 12px;
  }
  padding: 0 4px 0 16px;
  display: flex;
  align-items: center;
  justify-items: center;
  place-items: center;
  overflow: hidden;
  }

  .ic_shop {
    margin: 0;
    font-size: 14px;
    line-height: 14px;
    align-items: center;
    justify-items: center;
    place-items: center;
    color: #ed1e79;
    text-decoration: none;
    display: inline-block;
    @media screen and (max-width: $breakpoint) {
      width: 100%;
    }
  }

  .ic_shop_title {
    vertical-align: middle;
    font-family: "source-han-sans-japanese";
    font-size: 20px;
    @media screen and (max-width: $breakpoint) {
      font-size: 18px;
    }
    font-weight: 600;
  }

  .message_text {
    position: relative;
    margin: 0;
    width: 100%;
    color: #ED1E79;
    text-decoration: none;
    font-size: 14px;
    @media screen and (max-width: $breakpoint) {
      font-size: 12px;
      color:#676767;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/InformationShop.vue